import React from "react";
import ReactDOM from "react-dom/client";
import Machinery from "./machinery";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Machinery />
  </React.StrictMode>,
);
